var map = {
	"./PDF.svg": "./src/icons/svg/PDF.svg",
	"./audio.svg": "./src/icons/svg/audio.svg",
	"./back.svg": "./src/icons/svg/back.svg",
	"./baxiang.svg": "./src/icons/svg/baxiang.svg",
	"./baxiangActive.svg": "./src/icons/svg/baxiangActive.svg",
	"./bingli.svg": "./src/icons/svg/bingli.svg",
	"./binglike.svg": "./src/icons/svg/binglike.svg",
	"./calls.svg": "./src/icons/svg/calls.svg",
	"./changguijiancha.svg": "./src/icons/svg/changguijiancha.svg",
	"./changguijianchaActive.svg": "./src/icons/svg/changguijianchaActive.svg",
	"./changweiwaike.svg": "./src/icons/svg/changweiwaike.svg",
	"./clojin.svg": "./src/icons/svg/clojin.svg",
	"./clolaba.svg": "./src/icons/svg/clolaba.svg",
	"./confirm.svg": "./src/icons/svg/confirm.svg",
	"./dianshengli.svg": "./src/icons/svg/dianshengli.svg",
	"./dianshengliActive.svg": "./src/icons/svg/dianshengliActive.svg",
	"./down.svg": "./src/icons/svg/down.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./erbihouke.svg": "./src/icons/svg/erbihouke.svg",
	"./erke.svg": "./src/icons/svg/erke.svg",
	"./ertongkangfuke.svg": "./src/icons/svg/ertongkangfuke.svg",
	"./fangliao.svg": "./src/icons/svg/fangliao.svg",
	"./fangliaoActive.svg": "./src/icons/svg/fangliaoActive.svg",
	"./fangsheke.svg": "./src/icons/svg/fangsheke.svg",
	"./feike.svg": "./src/icons/svg/feike.svg",
	"./followup.svg": "./src/icons/svg/followup.svg",
	"./followupActive.svg": "./src/icons/svg/followupActive.svg",
	"./fuchanke.svg": "./src/icons/svg/fuchanke.svg",
	"./fuke.svg": "./src/icons/svg/fuke.svg",
	"./gandanwaike.svg": "./src/icons/svg/gandanwaike.svg",
	"./ganranke.svg": "./src/icons/svg/ganranke.svg",
	"./guke.svg": "./src/icons/svg/guke.svg",
	"./guzhi.svg": "./src/icons/svg/guzhi.svg",
	"./guzhiActive.svg": "./src/icons/svg/guzhiActive.svg",
	"./heyixueke.svg": "./src/icons/svg/heyixueke.svg",
	"./hualiao.svg": "./src/icons/svg/hualiao.svg",
	"./hualiaoActive.svg": "./src/icons/svg/hualiaoActive.svg",
	"./huxineike.svg": "./src/icons/svg/huxineike.svg",
	"./image.svg": "./src/icons/svg/image.svg",
	"./jianchaxiangmu.svg": "./src/icons/svg/jianchaxiangmu.svg",
	"./jianyanke.svg": "./src/icons/svg/jianyanke.svg",
	"./jibingmiaoshu.svg": "./src/icons/svg/jibingmiaoshu.svg",
	"./jibingmingcheng.svg": "./src/icons/svg/jibingmingcheng.svg",
	"./jibingyufang.svg": "./src/icons/svg/jibingyufang.svg",
	"./jibingyufang1.svg": "./src/icons/svg/jibingyufang1.svg",
	"./jin.svg": "./src/icons/svg/jin.svg",
	"./jingshen.svg": "./src/icons/svg/jingshen.svg",
	"./jingshenActive.svg": "./src/icons/svg/jingshenActive.svg",
	"./kangfuganranke.svg": "./src/icons/svg/kangfuganranke.svg",
	"./keshi.svg": "./src/icons/svg/keshi.svg",
	"./kouqiangke.svg": "./src/icons/svg/kouqiangke.svg",
	"./laba.svg": "./src/icons/svg/laba.svg",
	"./left.svg": "./src/icons/svg/left.svg",
	"./life.svg": "./src/icons/svg/life.svg",
	"./linchuangyingyangke.svg": "./src/icons/svg/linchuangyingyangke.svg",
	"./mazuike.svg": "./src/icons/svg/mazuike.svg",
	"./meirongzhengxingke.svg": "./src/icons/svg/meirongzhengxingke.svg",
	"./message_tip.svg": "./src/icons/svg/message_tip.svg",
	"./mimiaowaike.svg": "./src/icons/svg/mimiaowaike.svg",
	"./nanke.svg": "./src/icons/svg/nanke.svg",
	"./neifenmi.svg": "./src/icons/svg/neifenmi.svg",
	"./neifenmiActive.svg": "./src/icons/svg/neifenmiActive.svg",
	"./neifenmike.svg": "./src/icons/svg/neifenmike.svg",
	"./ningxiadianshenglizhongxin.svg": "./src/icons/svg/ningxiadianshenglizhongxin.svg",
	"./person_card.svg": "./src/icons/svg/person_card.svg",
	"./pifuke.svg": "./src/icons/svg/pifuke.svg",
	"./pinggujieguo.svg": "./src/icons/svg/pinggujieguo.svg",
	"./prevention.svg": "./src/icons/svg/prevention.svg",
	"./preventionActive.svg": "./src/icons/svg/preventionActive.svg",
	"./puneike.svg": "./src/icons/svg/puneike.svg",
	"./puwaike.svg": "./src/icons/svg/puwaike.svg",
	"./quanke.svg": "./src/icons/svg/quanke.svg",
	"./right.svg": "./src/icons/svg/right.svg",
	"./risk.svg": "./src/icons/svg/risk.svg",
	"./riskActive.svg": "./src/icons/svg/riskActive.svg",
	"./select.svg": "./src/icons/svg/select.svg",
	"./shenjingneike.svg": "./src/icons/svg/shenjingneike.svg",
	"./shenjingwaike.svg": "./src/icons/svg/shenjingwaike.svg",
	"./shenzangneike.svg": "./src/icons/svg/shenzangneike.svg",
	"./shijianpianlv.svg": "./src/icons/svg/shijianpianlv.svg",
	"./shiyanshi.svg": "./src/icons/svg/shiyanshi.svg",
	"./shiyanshiActive.svg": "./src/icons/svg/shiyanshiActive.svg",
	"./shoushu.svg": "./src/icons/svg/shoushu.svg",
	"./shoushuActive.svg": "./src/icons/svg/shoushuActive.svg",
	"./smrz.svg": "./src/icons/svg/smrz.svg",
	"./suifangzhiliao.svg": "./src/icons/svg/suifangzhiliao.svg",
	"./tijianzhongxin.svg": "./src/icons/svg/tijianzhongxin.svg",
	"./treatment.svg": "./src/icons/svg/treatment.svg",
	"./treatmentActive.svg": "./src/icons/svg/treatmentActive.svg",
	"./upload.svg": "./src/icons/svg/upload.svg",
	"./video.svg": "./src/icons/svg/video.svg",
	"./voice.svg": "./src/icons/svg/voice.svg",
	"./xiaohuaneike.svg": "./src/icons/svg/xiaohuaneike.svg",
	"./xinlike.svg": "./src/icons/svg/xinlike.svg",
	"./xinneike.svg": "./src/icons/svg/xinneike.svg",
	"./xinshengerke.svg": "./src/icons/svg/xinshengerke.svg",
	"./xinxiongwaike.svg": "./src/icons/svg/xinxiongwaike.svg",
	"./xueguanwaike.svg": "./src/icons/svg/xueguanwaike.svg",
	"./xueyeneike.svg": "./src/icons/svg/xueyeneike.svg",
	"./xuezhi.svg": "./src/icons/svg/xuezhi.svg",
	"./xuezhiActive.svg": "./src/icons/svg/xuezhiActive.svg",
	"./yanke.svg": "./src/icons/svg/yanke.svg",
	"./yaowuzhiliao.svg": "./src/icons/svg/yaowuzhiliao.svg",
	"./yaoxuebu.svg": "./src/icons/svg/yaoxuebu.svg",
	"./yijike.svg": "./src/icons/svg/yijike.svg",
	"./yingxiang.svg": "./src/icons/svg/yingxiang.svg",
	"./yingxiangActive.svg": "./src/icons/svg/yingxiangActive.svg",
	"./yingyangke.svg": "./src/icons/svg/yingyangke.svg",
	"./zhongliuneike.svg": "./src/icons/svg/zhongliuneike.svg",
	"./zhongliuwaike.svg": "./src/icons/svg/zhongliuwaike.svg",
	"./zhongyike.svg": "./src/icons/svg/zhongyike.svg",
	"./zhongzhengyixueke.svg": "./src/icons/svg/zhongzhengyixueke.svg",
	"./zhuan.svg": "./src/icons/svg/zhuan.svg",
	"./生活方式.svg": "./src/icons/svg/生活方式.svg",
	"./药物治疗.svg": "./src/icons/svg/药物治疗.svg",
	"./随访治疗.svg": "./src/icons/svg/随访治疗.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";